<script>
    import { createEventDispatcher } from "svelte";
    const dispatch = createEventDispatcher();

    import HeaderIntro from "../basic/HeaderIntro.svelte";

    import milkOptionsStore from "../../stores/milkOptions-store.js";
    let availableMilkOptions = $milkOptionsStore;

    export let userSelection;
    export let orderFrame;
    export let userdata;

    function searchForMilkOption(milkCode) {
        let milkOption;
        for (var prop in availableMilkOptions) {
            availableMilkOptions[prop].options.forEach((item) => {
                if (item.code == milkCode) {
                    milkOption = item;
                }
            });
        }

        if (typeof milkOption == "undefined") {
            alert("Milk Option not found: " + milkCode);
        } else {
            return milkOption;
        }
    }

    const toEuro = new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR",
    });

    let orderItems = [];
    //prepare orderItems
    for (var prop in userSelection.order.weekSlices) {
        let milkOption = searchForMilkOption(
            userSelection.order.weekSlices[prop]
        );
        let newOrderItem = {
            weekNo: prop < 10 ? "0" + prop : prop,
            name: milkOption.name,
            code: milkOption.code,
            pricePerDay: milkOption.pricePerDay,
        };
        orderItems.push(newOrderItem);
    }
    setTimeout(() => {
        dispatch("cleanOrderItems", orderItems);
    }, 100);
    
</script>

<HeaderIntro
    mainText={"Bestellzusammenfassung"}
    subText={`Bitte prüfe deine Bestellinformationen für KW${
        orderFrame.weekNoBegin < 10
            ? "0" + orderFrame.weekNoBegin
            : orderFrame.weekNoBegin
    } - KW${
        orderFrame.weekNoBegin < 10
            ? "0" + orderFrame.weekNoEnd
            : orderFrame.weekNoEnd
    }.`}
/>

<div class="row">
    <div class="col-lg-6">
        <div class="myContainer">
            <h4>Bestellung</h4>
            <ul>
                {#each orderItems as orderItem}
                    <li>
                        <div>KW{orderItem.weekNo}</div>
                        <div><b>{orderItem.name}</b></div>
                        <div class="tinyText">({toEuro.format(orderItem.pricePerDay)}/Tag)</div>
                    </li>
                {/each}
                <li class="money baseSum">
                    <div>Bestellsumme:</div>
                    <div><b>{toEuro.format(userSelection.order.baseSum)}</b></div>
                </li>
                <li class="money heroFee">
                    <div>Heldengebühr:</div>
                    <div><b>+ {toEuro.format(userSelection.order.heroFee)}</b></div>
                </li>
                <li class="money totalSum">
                    <div>Gesamtsumme: </div>
                    <div><b>{toEuro.format(userSelection.order.totalSum)}</b></div>
                </li>
            </ul>
        </div>
    </div>

    <div class="col-lg-6">
        <div class="myContainer">
            <h4>Käuferdaten</h4>
            <div class="rechnungsInfoList">
                <div>
                    <div>Name:</div>
                    <div><b>{userdata.firstName} {userdata.lastName}</b></div>
                </div>
                <div>
                    <div>Email-Adresse:</div>
                    <div><b>{userdata.email}</b></div>
                </div>
                <div>
                    <div>Anschrift:</div>
                    <div><b>{userdata.street}</b></div>
                </div>
                <div>
                    <div>PLZ und Ort:</div>
                    <div><b>{userdata.zip} {userdata.city}</b></div>
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .rechnungsInfoList {
        text-align: right;
    }
    .rechnungsInfoList > div,
    li {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: baseline;
    }
    li > div,
    .rechnungsInfoList > div > div {
        padding: 0 10px;
    }

    .tinyText {
        font-size: 11px;
    }

    .money.baseSum {
        margin-top: 10px;
        border-top: dashed 1.5px black;
        padding-top: 7px;
    }
    .money.totalSum {
        border-top: solid 1.5px black;
        border-bottom: double 4px black;
        margin-top: 3px;
        padding-top: 3px;
        padding-bottom: 3px;
    }

    ul {
        padding-left: 0;
        text-align: left;
        list-style-type: none;
        max-width: 350px;
    }
    h4 {
        margin-bottom: 25px;
    }
    .myContainer {
        background: white;
        padding: 30px;
        margin: 15px 5px;
        border-radius: 10px;
        border: solid 2px rgba(0, 0, 0, 0.2);
        box-shadow: 0 0 20px rgb(0 0 0 / 5%);
        display: flex;
        flex-direction: column;
        align-items: center;
    }
</style>
